import { defineMessages } from 'react-intl'

export const MACRONUTRIENT = {
  PROTEIN: 'PROTEIN',
  CARBS: 'CARBS',
  FAT: 'FAT'
}

export const MACRONUTRIENT_TO_CALORIES_PER_GRAM = {
  [MACRONUTRIENT.PROTEIN]: 4,
  [MACRONUTRIENT.CARBS]: 4,
  [MACRONUTRIENT.FAT]: 9
}

export const MACRONUTRIENT_TO_ICON = {
  [MACRONUTRIENT.PROTEIN]: '🍗',
  [MACRONUTRIENT.CARBS]: '🍞',
  [MACRONUTRIENT.FAT]: '🥑'
}

const messages = defineMessages({
  protein: {
    id: 'Macronutrient.protein',
    defaultMessage: 'Protein'
  },
  carbs: {
    id: 'Macronutrient.carbs',
    defaultMessage: 'Carbs'
  },
  fat: {
    id: 'Macronutrient.fat',
    defaultMessage: 'Fat'
  }
})

export const MACRONUTRIENT_TO_MESSAGE = {
  [MACRONUTRIENT.PROTEIN]: messages.protein,
  [MACRONUTRIENT.CARBS]: messages.carbs,
  [MACRONUTRIENT.FAT]: messages.fat
}

export const MACRO_MIN_PERCENTAGE = 1
export const MACRO_MAX_PERCENTAGE = 80

export const MACRO_BAR_MIN_WIDTH = 100
export const MACRO_BAR_MAX_WIDTH = 340
export const MACRO_MIN_PERCENTAGE_WIDTH = 20
export const MACRO_MAX_PERCENTAGE_WIDTH = 40
